@if (_isOpen()) {
    @if (!product().orderConfig.companiesOnly && showMinorsNote()) {
        <p class="p-24:t md:p-32:t lg:p-48:t c:headline">
            Bei Minderjährigen gibst du bitte die Daten eines Erziehungsberechtigten an.
        </p>
    }
    <form
        [formGroup]="form"
        (submit)="submit()"
        [ngClass]="{ 'p-24:t md:p-32:t lg:p-48:t': product().orderConfig.companiesOnly || !showMinorsNote() }"
    >
        <div class="grid-container p-12:t md:p-16:t lg:p-24:t">
            <!-- #region title -->
            @if (!product().orderConfig.companiesOnly && titles()) {
                <div class="g-12">
                    <div class="form-control grid-container">
                        @for (title of titles(); track title.id) {
                            <div class="g-auto">
                                <input
                                    [id]="'radio-title-' + title.description"
                                    type="radio"
                                    formControlName="title"
                                    [value]="title.id"
                                />
                                @if (!product().orderConfig.naturalPersonsOnly || title.id !== companyTitleId) {
                                    <label [for]="'radio-title-' + title.description">
                                        {{ title.description }}
                                    </label>
                                }
                            </div>
                        }
                    </div>
                </div>
            }
            <!-- #endregion -->
            <!-- #region company name -->
            @if (isCompany()) {
                <div class="g-12 form-control">
                    <label
                        for="company-input"
                        appReactiveLabel
                        formControlName="company"
                        >Schule/Verein/Firma*:
                    </label>
                    <input
                        id="company-input"
                        type="text"
                        class="required"
                        placeholder="Schule/Verein/Firma*"
                        formControlName="company"
                        [ctrlErrorMessage]="companyErrorMessages"
                        required
                    />
                </div>
            }
            <!-- #endregion -->
            <!-- #region customer name -->
            <div class="g-12 lg:g-6 form-control">
                <label
                    for="first-name-input"
                    appReactiveLabel
                    formControlName="firstName"
                >
                    {{ isCompany() ? 'Vorname Ansprechpartner*' : 'Vorname*' }}:
                </label>
                <input
                    id="first-name-input"
                    type="text"
                    [placeholder]="isCompany() ? 'Vorname Ansprechpartner*' : 'Vorname*'"
                    formControlName="firstName"
                    [ctrlErrorMessage]="firstNameErrorMessages"
                    required
                />
            </div>
            <div class="g-12 lg:g-6 form-control">
                <label
                    for="last-name-input"
                    appReactiveLabel
                    formControlName="lastName"
                    >{{ isCompany() ? 'Nachname Ansprechpartner*' : 'Nachname*' }}:</label
                >
                <input
                    id="last-name-input"
                    type="text"
                    [placeholder]="isCompany() ? 'Nachname Ansprechpartner*' : 'Nachname*'"
                    formControlName="lastName"
                    [ctrlErrorMessage]="lastNameErrorMessages"
                    required
                />
            </div>
            <!-- #endregion -->
            <!-- #region address -->
            <div class="g-12 form-control">
                <label
                    for="street-input"
                    appReactiveLabel
                    formControlName="street"
                >
                    Straße & Hausnummer*
                </label>
                <input
                    id="street-input"
                    type="text"
                    placeholder="Straße und Hausnummer*"
                    formControlName="street"
                    [ctrlErrorMessage]="streetErrorMessages"
                    required
                />
            </div>
            <div class="g-12 lg:g-4 form-control">
                <label
                    for="zip-input"
                    appReactiveLabel
                    formControlName="zip"
                    >Postleitzahl*:</label
                >
                <input
                    id="zip-input"
                    type="text"
                    inputmode="numeric"
                    pattern="[0-9.]*"
                    placeholder="Postleitzahl*"
                    formControlName="zip"
                    [ctrlErrorMessage]="zipErrorMessages"
                    required
                />
            </div>
            <div class="g-12 lg:g-8 form-control">
                <label
                    for="city-input"
                    appReactiveLabel
                    formControlName="city"
                    >Stadt*:</label
                >
                <input
                    id="city-input"
                    type="text"
                    placeholder="Stadt*"
                    formControlName="city"
                    required
                    [ctrlErrorMessage]="cityErrorMessages"
                />
            </div>
            <div class="g-12 form-control">
                <label
                    for="state"
                    appReactiveLabel
                    formControlName="state"
                    >Bundesland*:</label
                >
                <select
                    id="state"
                    formControlName="state"
                    [ctrlErrorMessage]="stateErrorMessages"
                    required
                >
                    <option
                        [ngValue]="null"
                        disabled
                    >
                        {{ 'Bundesland' | formLabel: true : 'select' }}
                    </option>
                    @for (state of states; track state) {
                        <option [value]="state">{{ state }}</option>
                    }
                </select>
            </div>
            <!-- #endregion -->
            <!-- #region contact data -->
            <div class="g-12 form-control">
                <label
                    for="mail-input"
                    appReactiveLabel
                    formControlName="mail"
                    >E-Mail*:</label
                >
                <input
                    type="email"
                    placeholder="E-Mail*"
                    id="mail-input"
                    formControlName="mail"
                    [ctrlErrorMessage]="mailErrorMessages"
                    required
                />
            </div>
            <div
                class="g-12 form-control"
                [ngClass]="{ 'xl:g-6': !isCompany() }"
            >
                <label
                    for="phone-input"
                    appReactiveLabel
                    formControlName="phone"
                    >Telefon*:</label
                >
                <input
                    type="tel"
                    placeholder="Telefon*"
                    id="phone-input"
                    formControlName="phone"
                    [ctrlErrorMessage]="phoneErrorMessages"
                    required
                />
            </div>
            <!-- #endregion -->
            <!-- #region birthday -->
            @if (!isCompany()) {
                <div class="g-12 xl:g-6 form-control">
                    <label
                        for="date-of-birth-input"
                        appReactiveLabel
                        formControlName="dateOfBirth"
                        >Geburtstag (tt.mm.jjjj)*:</label
                    >
                    <input
                        id="date-of-birth-input"
                        ctrlDateInput
                        type="text"
                        placeholder="Geburtstag (tt.mm.jjjj)*"
                        formControlName="dateOfBirth"
                        [ctrlErrorMessage]="dateOfBirthErrorMessages()"
                        required
                    />
                </div>
            }
            <!-- #endregion -->
        </div>
        <app-required-info></app-required-info>
        <app-navigation-buttons
            [nextDisabled]="form.invalid"
            [showBack]="isFirstStep"
            (prev)="btnPrev()"
            (next)="submit()"
            nextTooltip="Bitte fülle alle erforderlichen Felder aus."
        ></app-navigation-buttons>
    </form>
}
